import React from 'react'
import Select from 'react-select'

export default (props) => {
    const [input, setInput] = React.useState('')
    const [searchedList, setSearchedlist] = React.useState([])

    function onSelect(e) {
        if (props.onSelect) {
            props.onSelect(e)
        }
    }

    React.useEffect(() => {
        document
            .querySelector('#auto_complete')
            .addEventListener(
                'keypress',
                function (e) {
                    if (props.request) {
                        props.request({ [props.queryField]: input })
                            .then(resp => {
                                const temp = resp.map(item => (
                                    {
                                        "value": item[props.valueField],
                                        "label": item[props.labelField]
                                    }
                                ))
                                setSearchedlist(temp)
                            })
                    }
                });
    }, [])

    return <Select
        id={'auto_complete'}
        isLoading={props.loading}
        placeholder={props.placeholder || "Digite aqui"}
        inputValue={input}
        onChange={onSelect}
        onInputChange={setInput}
        noOptionsMessage={s => "Sem resultados"}
        options={searchedList}
    />
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/AutoComplete.jsx